/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=9f73c086"
const script = {}

import "./App.vue?vue&type=style&index=0&id=9f73c086&lang=scss"

import exportComponent from "/Users/shenhao/workDocument/idea/IDEACode/YKWebCode/shaoguanFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__